import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src", "alt", "observerProps", "imgClassName", "className", "size", "isLazy", "status", "defaultAvatarColor", "userName", "spanElProps"];
import { useMemo } from 'react';
import { clsx } from 'clsx';
import LazyImage from "../LazyImage";
import { KAVATAR_SIZE_CLASSES } from "./constants";
import { StatusCircle } from "./StatusCircle";
import { getAvatarSrc, getDefaultAvatarSrc } from "./utils";

/**
 * TODO:
 * - Add responsive?
 */

/**
 * Used to visually represent an user or entity
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Avatar = function Avatar(_ref) {
  var srcProp = _ref.src,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? 'avatar' : _ref$alt,
    observerProps = _ref.observerProps,
    imgClassNameProp = _ref.imgClassName,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    _ref$isLazy = _ref.isLazy,
    isLazy = _ref$isLazy === void 0 ? true : _ref$isLazy,
    status = _ref.status,
    _ref$defaultAvatarCol = _ref.defaultAvatarColor,
    defaultAvatarColor = _ref$defaultAvatarCol === void 0 ? 'purple' : _ref$defaultAvatarCol,
    userName = _ref.userName,
    spanElProps = _ref.spanElProps,
    avatarProps = _objectWithoutProperties(_ref, _excluded);
  var _useMemo = useMemo(function () {
      return getAvatarSrc({
        src: srcProp,
        size: size
      });
    }, [srcProp, size]),
    src = _useMemo.src;
  var defaultAvatarSrc = useMemo(function () {
    return getDefaultAvatarSrc({
      defaultAvatarColor: defaultAvatarColor,
      size: size
    });
  }, [defaultAvatarColor, size]);
  var sizeClasses = KAVATAR_SIZE_CLASSES[size];
  var imgClassName = clsx(['tw-w-full', 'tw-h-full', 'tw-rounded-full', 'tw-overflow-hidden'], imgClassNameProp);
  var defaultAvatar = /*#__PURE__*/_jsx("span", {
    className: imgClassName,
    style: {
      backgroundImage: "url(".concat(defaultAvatarSrc, ")"),
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }
  });
  var renderImage = function renderImage(imageSrc, renderLazily) {
    return renderLazily ? /*#__PURE__*/_jsx(LazyImage, {
      className: imgClassName,
      imgClassName: "tw-object-cover tw-w-full tw-h-full",
      placeholder: defaultAvatarSrc,
      src: imageSrc,
      alt: alt,
      observerProps: observerProps
    }) : /*#__PURE__*/_jsx("img", {
      className: imgClassName,
      style: {
        objectFit: 'cover'
      },
      src: src,
      alt: alt
    });
  };
  return /*#__PURE__*/_jsxs("span", _objectSpread(_objectSpread(_objectSpread({}, avatarProps), spanElProps), {}, {
    className: clsx('tw-relative tw-inline-flex tw-items-center tw-justify-center tw-flex-shrink-0', className, sizeClasses),
    children: [src ? renderImage(src, isLazy) : defaultAvatar, size !== 'xs' && status && /*#__PURE__*/_jsx(StatusCircle, {
      size: size,
      status: status,
      userName: userName,
      className: clsx({
        'tw-bg-success-400': status === 'online',
        'tw-bg-neutral-light-700': status === 'offline'
      })
    })]
  }));
};
export default Avatar;